import React from 'react';
import PropTypes from 'prop-types';
import { isString } from 'lodash';
import { LocaleService } from '@sm360/widget-commons-core-services';
import 'vdp-used/components/WarrantiesAndPolicies/WarrantiesAndPolicies.scss';

const WarrantyInfo = ({ warrantyText }) => {
    if (warrantyText === '' || !isString(warrantyText)) {
        return null;
    }
    /*  eslint-disable react/no-danger */
    return (
        <div className="vdp-information__warranty-info">
            <p className="vdp-information__subtitle sr-text is-bold">
                {LocaleService.t('VDP_USED.WARRANTY.DESCRIPTION')}
            </p>

            <p className="car-desc warranty-text__information" dangerouslySetInnerHTML={{ __html: warrantyText }} />
        </div>
    );
};

WarrantyInfo.defaultProps = {
    warrantyText: '',
};
WarrantyInfo.propTypes = {
    warrantyText: PropTypes.string,
};

WarrantyInfo.displayName = 'WarrantyInfo';

export default WarrantyInfo;
